<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="agent_bill_id"
    >
      <div slot="item_no" slot-scope="item_no, record">
        <div v-if="isShowMenu('agent_purchase_items/show')">
          <a @click="showInfoModal(record.purchase_item_id)">{{ item_no }}</a>
        </div>
        <div v-else>
          {{ item_no }}
        </div>
      </div>
    </a-table>
    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <show-agent-purchase-item
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { findAgentConsumptionCpePurchaseBills } from '@/api/agent_consumption_bill'
import { hasPermission } from '@/utils/permission'
import { formatBigNumber, formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentCpePurchaseConsumptionBillList',
  components: {
    Pagination,
    ShowAgentPurchaseItem: () => import('@/views/agent_consumption_bills/purchase/Show')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowInfoModal: false,
      showingId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        { title: '项目批次', dataIndex: 'item_no', scopedSlots: { customRender: 'item_no' }, width: 235 },
        { title: '账单时间', dataIndex: 'bill_time', width: 200 },
        { title: 'CPE商品', dataIndex: 'agents_product_name', width: 220 },
        { title: '采购数量', dataIndex: 'product_count', customRender: formatBigNumber, width: 100 },
        { title: '单价(元)', dataIndex: 'product_price', customRender: formatCurrency, width: 100 },
        { title: '商品费用(元)', dataIndex: 'product_fee', customRender: formatCurrency, width: 120 },
        { title: '快递费(元)', dataIndex: 'shipping_fee', customRender: formatCurrency, width: 100 },
        { title: '账单金额(元)', dataIndex: 'total_fee', customRender: formatCurrency, width: 120 },
        { title: '备注', dataIndex: 'remark', width: 100, ellipsis: true }
      ]
    },
    agentId() {
      if (this.$route.query.agent_id) {
        return parseInt(this.$route.query.agent_id)
      }
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    showInfoModal(recordId) {
      this.showingId = recordId
      this.isShowInfoModal = true
    },
    fetchData() {
      this.loading = true
      findAgentConsumptionCpePurchaseBills(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
